import React from "react";
import { ErrorBoundary } from "./Components/ErrorBoundary";
import Userprovider from "./Context/User";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import msalConfig from "./Services/Config/ConfigMsal";

import Router from "./Routes/routes";

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
    return (
        <ErrorBoundary>
            <Userprovider>
                <MsalProvider instance={msalInstance}>
                    <Router />
                </MsalProvider>
            </Userprovider>
        </ErrorBoundary>
    );
}

export default App;
